import React, { useState, useEffect, Fragment } from "react";
import {
  AppBar,
  IconButton,
  Grid,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  Button,
  Box,
  Snackbar,
  CircularProgress,
  DialogActions,
  Drawer,
  List,
  ListItem,
} from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import { Route, Switch, useHistory } from "react-router-dom";
import CloseIcon from "@material-ui/icons/Close";
import MenuIcon from "@material-ui/icons/Menu";
import AccountBalanceWalletSharpIcon from "@material-ui/icons/AccountBalanceWalletSharp";
import CheckSharpIcon from "@material-ui/icons/CheckSharp";
import ErrorSharpIcon from "@material-ui/icons/ErrorSharp";
import { RootState, RootDispatch } from "./model";
import { useRematch } from "./utils/useRematch";

import Banner from "./component/Banner";
import Roadmap from "./component/Roadmap";
import Team from "./component/Team";
import Footer from "./component/Footer";
import About from "./component/About";
import MintModal from "./component/MintModal";
import CountDown from "./component/CountDown";
import GameDesc from "./component/GameDesc";
import Grant from "./component/Grant";
import Star from "./component/Star";
import Fight from "./component/Fight";
import Game from "./component/Game";
import logo from "./assets/logo.png";
import MetaMaksLogo from "./assets/metamask-logo.svg";
// import ETH from "./assets/eth.svg";
import "./App.less";

import { PROD_OPENTIME, TEST_OPENTIME } from "./const/config";

const OPENTIME = PROD_OPENTIME;

const mapState = (state: RootState) => ({
  ...state.main,
  loading: state.loading,
  modalState: { ...state.modal },
});

const mapDispatch = (dispatch: RootDispatch) => ({
  ...dispatch.main,
  ...dispatch.modal,
});

function App() {
  // const [isMobile, setIsMobile] = useState(false);
  // const [isFooterFixed, setIsFooterFixed] = useState(false);

  let history = useHistory();

  // const handleResize = () => {
  //   // eslint-disable-next-line no-restricted-globals
  //   screen.width <= 500 ? setIsMobile(true) : setIsMobile(false);
  //   // eslint-disable-next-line no-restricted-globals
  //   screen.height <= 650 ? setIsFooterFixed(true) : setIsFooterFixed(false);
  // };

  // useEffect(() => {
  //   // 监听
  //   window.addEventListener("resize", handleResize);
  //   handleResize();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  const [
    {
      userInfo,
      modalState,
      alertState,
      loading,
      isMainNet,
      transactionModalState,
      KungFuHeroContract,
    },
    {
      setFields,
      init,
      connectWallet,
      openModal,
      closeModal,
      closeAlert,
      setTransactionModal,
      fetchGameContractData,
    },
  ] = useRematch(mapState, mapDispatch);

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchGameContractData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo, KungFuHeroContract]);

  const [drawerOpen, setDrawerOpen] = useState(false);

  const LinkPage = (path: string) => {
    // if (path === window.location.pathname) {
    //   return;
    // }
    history.push(path);
  };

  return (
    <div className="App">
      <Star />
      <Box display={{ xs: "none", md: "block" }}>
        <AppBar position="static" color="primary" className="navigation">
          <Grid container alignItems="center" className="navigation-content">
            <Grid item>
              <Grid container alignItems="center" spacing={4}>
                <Grid
                  item
                  xs={12}
                  md={4}
                  onClick={() => {
                    LinkPage("/");
                  }}
                >
                  <img src={logo} width="100%" alt="" />
                </Grid>
                <Grid item>
                  <Typography
                    variant="h6"
                    component="div"
                    className="navigation-btn"
                  >
                    <Button
                      color="inherit"
                      size="large"
                      variant="text"
                      onClick={() => {
                        LinkPage("/");
                      }}
                    >
                      main
                    </Button>
                    {/* <Button
                      color="inherit"
                      size="large"
                      variant="text"
                      onClick={() => {
                        LinkPage("/gallery");
                      }}
                    >
                      gallery
                    </Button> */}
                    {/* <Button
                      color="inherit"
                      size="large"
                      variant="text"
                      onClick={() => {
                        LinkPage("/grant");
                      }}
                    >
                      grant
                    </Button> */}
                    <Button
                      color="inherit"
                      size="large"
                      variant="text"
                      onClick={() => {
                        LinkPage("/game");
                      }}
                    >
                      Treasure Hunt
                    </Button>
                    <Button
                      color="inherit"
                      size="large"
                      variant="text"
                      onClick={() => {
                        LinkPage("/fight");
                      }}
                    >
                      Fighting Game
                    </Button>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Snackbar
              open={alertState.open}
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
              // autoHideDuration={6000}
              onClose={closeAlert}
            >
              <MuiAlert
                elevation={6}
                variant="filled"
                onClose={closeAlert}
                severity={alertState.type}
              >
                {alertState.content}
              </MuiAlert>
            </Snackbar>
            <Snackbar
              open={!isMainNet}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
              <MuiAlert elevation={6} variant="filled" severity="error">
                Please Switch to the ETH Main NetWork.
              </MuiAlert>
            </Snackbar>
            <Grid item style={{ marginLeft: "auto" }}>
              {userInfo.address ? (
                <Button
                  variant="contained"
                  color="secondary"
                  size="large"
                  startIcon={<AccountBalanceWalletSharpIcon />}
                >
                  {`${userInfo.address.substring(
                    0,
                    6
                  )}...${userInfo.address.substring(
                    userInfo.address.length - 6,
                    userInfo.address.length
                  )}`}
                </Button>
              ) : (
                <Button
                  variant="contained"
                  color="secondary"
                  size="large"
                  disabled={loading.effects.main.connectWallet}
                  onClick={() => {
                    openModal("connectWallet");
                  }}
                >
                  Connect Wallet
                </Button>
              )}
            </Grid>
          </Grid>
        </AppBar>
      </Box>
      <Box display={{ xs: "block", md: "none" }}>
        <AppBar position="static" color="primary" className="navigation-mobile">
          <Grid
            container
            alignItems="flex-start"
            justify="space-between"
            wrap="nowrap"
          >
            <Grid item xs={2}>
              <IconButton
                size="medium"
                edge="start"
                color="inherit"
                aria-label="menu"
                onClick={() => {
                  setDrawerOpen(true);
                }}
              >
                <MenuIcon />
              </IconButton>
            </Grid>
            <Grid item xs={10}>
              <img src={logo} width="100%" alt="" />
            </Grid>
          </Grid>
          <Box display={{ xs: "block", md: "none" }}>
            <Drawer
              anchor={"top"}
              open={drawerOpen}
              style={{ background: "#212121" }}
            >
              <List>
                <ListItem
                  button
                  onClick={() => {
                    LinkPage("/");
                    setDrawerOpen(false);
                  }}
                >
                  MAIN
                </ListItem>
                {/* <ListItem
                  button
                  onClick={() => {
                    LinkPage("/gallery");
                    setDrawerOpen(false);
                  }}
                >
                  GALLERY
                </ListItem> */}
                {/* <ListItem
                  button
                  onClick={() => {
                    LinkPage("/grant");
                    setDrawerOpen(false);
                  }}
                >
                  GRANT
                </ListItem> */}
                <ListItem
                  button
                  onClick={() => {
                    LinkPage("/game");
                    setDrawerOpen(false);
                  }}
                >
                  Treasure Hunt
                </ListItem>
                <ListItem
                  button
                  onClick={() => {
                    LinkPage("/fight");
                  }}
                >
                  Fighting Game
                </ListItem>
              </List>
            </Drawer>
          </Box>
        </AppBar>
      </Box>
      <Switch>
        <Route path="/fight">
          <Fight />
        </Route>
        {/* <Route path="/grant">
          <Fragment>
            <MintModal />
            <Grant />
          </Fragment>
        </Route> */}
        <Route path="/game">
          <CountDown date={OPENTIME.game}>
            <Game />
          </CountDown>
        </Route>
        <Route path="/">
          <MintModal />
          <Banner />
          <About />
          <GameDesc />
          <Roadmap />
          <Team />
        </Route>
      </Switch>
      <Dialog
        open={modalState.connectWallet}
        keepMounted
        onClose={closeModal}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>
          <div className="dialog-title">
            <Typography variant="h6">Connect Wallet</Typography>
            <IconButton aria-label="close" onClick={closeModal}>
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                connectWallet();
              }}
            >
              <div className="wallet-box">
                <img src={MetaMaksLogo} width="100%" alt="" />
              </div>
            </Button>
          </DialogContentText>
        </DialogContent>
      </Dialog>
      <Dialog
        open={transactionModalState.open}
        keepMounted
        onClose={() => {
          setTransactionModal({
            ...transactionModalState,
            open: false,
          });
        }}
        className="transaction-modal"
        disableEscapeKeyDown={false}
        fullWidth
        maxWidth="sm"
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>
          <div className="dialog-title">
            <Typography variant="h6" component="div">
              {transactionModalState.status === 0
                ? "Transaction pending..."
                : transactionModalState.status === 1
                ? "The transaction has been confirmed"
                : "Transaction fails"}
            </Typography>
            {transactionModalState.status !== 0 && (
              <IconButton
                aria-label="close"
                onClick={() => {
                  setTransactionModal({
                    ...transactionModalState,
                    open: false,
                  });
                }}
              >
                <CloseIcon />
              </IconButton>
            )}
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-slide-description"
            className="transaction-modal-content"
            component="div"
          >
            {transactionModalState.status === 0 ? (
              <CircularProgress color="secondary" size={60} />
            ) : transactionModalState.status === 1 ? (
              <CheckSharpIcon style={{ fontSize: 60 }} color="secondary" />
            ) : (
              <ErrorSharpIcon style={{ fontSize: 60, color: "red" }} />
            )}
            <div className="text">
              {transactionModalState.status === 0
                ? "Wait for the transaction confirmation..."
                : transactionModalState.status === 1
                ? "Success!"
                : transactionModalState.errorMsg}
            </div>
            {transactionModalState.txHash && (
              <div className="txhash-lin">
                <a
                  href={`https://etherscan.io/tx/${transactionModalState.txHash}`}
                  target="blank"
                >
                  TxHash:{" "}
                  {`${transactionModalState.txHash.substring(0, 20)}...`}
                </a>
              </div>
            )}
            {transactionModalState.status === 1 && (
              <Fragment>
                <div className="txhash-lin">
                  <a
                    href={`https://opensea.io/${userInfo.address}?search[query]=KungFu Hero`}
                    target="blank"
                  >
                    CHECK ON OPENSEA
                  </a>
                </div>
                <div className="txhash-lin">
                  You will see your KungFu Heroes in 10-20 minutes on Opensea
                </div>
              </Fragment>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            disabled={transactionModalState.status === 0}
            onClick={() => {
              setTransactionModal({
                ...transactionModalState,
                open: false,
              });
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
      {history.location.pathname === "/" && <Footer />}
    </div>
  );
}

export default App;
